import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { Route } from 'react-router-dom'
import App from './App'
import I18nContainer from './I18nContainer'

const Root = ({ store }) => (
  <Provider store={store}>
    <I18nContainer>
      <Route path="/" component={App} />
    </I18nContainer>
  </Provider>
)

Root.propTypes = {
  store: PropTypes.object.isRequired,
}
export default Root
